export default {
  'receipt.title': 'Receipt Information',
  'receipt.btn.add': 'Add Receipt',
  'receipt.btn.import': 'Import Receipt',
  'receipt.btn.export': 'Export Receipt',
  'receipt.input.placeholder': 'Please input receipt',
};
